export default __webpack_public_path__ + "static/media/grafico_01.6b977f7e.png";